export const LS_KEY = "sac_step7_generado";

export const STEP_LABELS = {
  mongo: "Sesión",
  word: "Documento Word",
  pdf: "Documento PDF",
  html: "Vista HTML",
  comparativa: "Comparativa con el documento del docente",
};

export const STEP_DESCRIPTIONS = {
  inicio: "Iniciando generación de la sesión...",
  competencias: "Cargando competencias y desempeños...",
  prompt_1: "Definiendo desempeños de aprendizaje...",
  videos: "Buscando videos educativos...",
  prompt_2: "Preparando la estructura de la sesión...",
  prompt_3: "Generando la secuencia pedagógica...",
  prompt_4: "Desarrollando la actividad central...",
  prompt_5: "Construyendo el cierre...",
  prompt_6: "Definiendo acciones previas...",
  prompt_7: "Generando lista de cotejo...",
  prompt_8: "Definiendo criterios de evaluación...",
  prompt_9: "Creando ficha de trabajo...",
  prompt_10: "Generando banco de preguntas...",
  final: "Finalizando generación...",
};

export const DEFAULT_ROW_VALUES = {
  situacion: "Situación significativa no asignada.",
  tema: "Tema pendiente.",
  descripcion: "Descripción no definida.",
};

export const getIdPSQL = (fila) =>
  fila?.id_PSQL ??
  fila?.id_psql ??
  fila?.idPsql ??
  fila?.id_psql_sesion ??
  fila?.id;

export const rowKey = (fila) => {
  const id = getIdPSQL(fila);
  return id ? `psql-${id}` : `unidad-${fila?.unidadId}-sesion-${fila?.nroSesion}`;
};

export const buildSnapshot = (fila) => ({
  id_PSQL: getIdPSQL(fila),
  competencia: fila.competencia,
  capacidades: fila.capacidades,
  desempenos: fila.desempenos,
  tema: fila.tema,
  descripcion: fila.descripcion,
  situacion: fila.situacion,
  unidad: fila.unidad,
  nroUnidad: fila.nroUnidad,
  nroSesion: fila.nroSesion,
  fileId: fila.fileId ?? fila.file_id ?? null,
});

export const hasChanged = (fila, snapshot) =>
  !snapshot || JSON.stringify(buildSnapshot(fila)) !== JSON.stringify(snapshot);

export const enrichRowsWithMetadata = async (rows, fetchers) => {
  if (!rows.length) return [];

  const niveles = await fetchers.listLevels();
  const gradosCache = {};
  const areasCache = {};

  return Promise.all(
    rows.map(async (fila) => {
      if (!gradosCache[fila.nivel]) {
        gradosCache[fila.nivel] = await fetchers.listGradesByLevel(fila.nivel);
      }

      if (!areasCache[fila.nivel]) {
        areasCache[fila.nivel] = await fetchers.listAreasByLevel(fila.nivel);
      }

      const fileIdActual = fila.fileId ?? fila.file_id ?? null;

      return {
        ...fila,

        fileId: fileIdActual,
        file_id: fileIdActual,
        nivelNombre: niveles.find((n) => n.id === fila.nivel)?.nombre,
        gradoNombre: gradosCache[fila.nivel].find((g) => g.id === fila.grado)?.descripcion,
        areaNombre: areasCache[fila.nivel].find((a) => a.id === fila.area)?.nombre,
      };
    })
  );
};

// export const buildSessionPayload = ({
//   fila,
//   competenciaTxt,
//   capacidadesTxt,
//   desempenosTxt,
// }) => ({
//   sesiones_data: [
//     {
//       id_PSQL: String(getIdPSQL(fila)),
//       tipo_sesion: "SAC",
//       nivel: fila.nivelNombre,
//       grado: Number(fila.gradoNombre),
//       area_tematica: fila.areaNombre,
//       tema: fila.tema,
//       objetivo: fila.descripcion,
//       unidad: fila.unidad,
//       nro_unidad: fila.nroUnidad,
//       situacion_significativa: fila.situacion,
//       nro_sesion: fila.nroSesion,
//       file_id:fila.fileId??fila.file_id??null,
//     },
//   ],
//   estandares_ap: {
//     competencia: competenciaTxt,
//     capacidades: capacidadesTxt,
//     desempenios: desempenosTxt,
//   },
// });

export const buildSessionPayload = ({
  fila,
  competenciaTxt,
  capacidadesTxt,
  desempenosTxt,
}) => {
  const fileIdActual =
    fila?.fileId ??
    fila?.file_id ??
    null;

  const payload = {
    sesiones_data: [
      {
        id_PSQL:
          String(
            getIdPSQL(fila)
          ),

        tipo_sesion:
          "SAC",

        nivel:
          fila.nivelNombre,

        grado:
          Number(
            fila.gradoNombre
          ),

        area_tematica:
          fila.areaNombre,

        tema:
          fila.tema,

        objetivo:
          fila.descripcion,

        unidad:
          fila.unidad,

        nro_unidad:
          fila.nroUnidad,

        situacion_significativa:
          fila.situacion,

        nro_sesion:
          fila.nroSesion,

        /*
         * Archivo temporal subido a OpenAI.
         */
        file_id:
          fileIdActual,
      },
    ],

    estandares_ap: {
      competencia:
        competenciaTxt,

      capacidades:
        capacidadesTxt,

      desempenios:
        desempenosTxt,
    },
  };

  // console.log(
  //   "FILA usada para generar sesión:",
  //   fila
  // );

  // console.log(
  //   "FILE ID usado para generar sesión:",
  //   fileIdActual
  // );

  // console.log(
  //   "PAYLOAD generar-sesion:",
  //   payload
  // );

  return payload;
};